import { PlessResponderSub } from '../../../../kymw00/pless-responder-sub.service';
import { OrderNumQuotaCodeComboBoxModel } from '../order-num-quota-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { OrderNumQuota } from '../order-num-quota.model';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 注文コード割当コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetOrderNumQuotaListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderNumQuotaListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: OrderNumQuotaCodeComboBoxModel;
  private orderCode: string = null;
  private mediumType: string = null;
  private multiPublishFlg: string = null;

  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderNumQuotaListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        MediumType: this.mediumType,
        MultiPublishFlg: this.multiPublishFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {OrderNumQuotaCodeComboBoxModel} model
   * @param {string} orderCode
   * @param {string} mediumType
   * @param {string} multiPublishFlg
   * @param {() => void} [successFunc=null] 成功時後続処理
   * @memberof GetOrderNumQuotaListService
   */
  execute(model: OrderNumQuotaCodeComboBoxModel,
    orderCode: string,
    mediumType: string,
    multiPublishFlg: string,
    successFunc: () => void = null) {

    this.model = model;
    this.orderCode = orderCode;
    this.mediumType = mediumType;
    this.multiPublishFlg = multiPublishFlg;
    this.successFunc = successFunc;
    this.send('KYMW02getOrderNumQuotaList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: any) {
    this.model.updateOrderNumQuotaList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
